import React from 'react';

import Page from '../../../components/page/Page';
import SelectOrganizationModal from '../components/SelectOrganizationModal';
import { t } from 'utils/language';

import type { LocationWindow } from 'types';

type Props = {
  location: LocationWindow
};

const SelectOrganizationPage = ({ location }: Props) => (
  <Page
    documentTitle={t('select_organization_page')}
  >
    <SelectOrganizationModal
      next={location.query.next}
    />
  </Page>
);

export default SelectOrganizationPage;
